<template>
  <PaFrontForm
    class="pa-message-additional-box"
    :class="additionalFormClass"
    :action="'/'"
    :formSetClass="['form-set-primary']"
    :formSet="formSet"
    :submitText="'申請する'"
    :submitLoading="isFormLoading"
    :isDisabledButton="isDisabledButton"
    :validationMessagePosition="'bottom'"

    :hasCancelButton="true"
    :cancelText="'やめる'"
    
    @handleSubmit="handleSubmit"
    @handleCancel="handleCancel"
  />
</template>

<script>
import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'
import StoryItemUseModalMixin     from '@/mixins/StoryItemUseModalMixin.js'

import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

export default {
  props : {
    isLoading   : {
      default: false,
    },

    isDisabled  : {
      default: false,
    },

    serverValidationError : {
      default: null
    },
  },

  mixins : [
    FormValidationControlMixin,
    StoryItemUseModalMixin
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      isFormLoading : false,

      formSet       : {
        name       : {
          label             : 'ひろばの名前',
          description       : 'ひろばの名前は10文字以内です。',
          validationRules   : ['notEmpty', 'max'],
          inputType         : 'input',
          isDisabled        : false,
          descriptionMinify : true,
        },
        caption  : {
          label             : 'ひろばの一言説明',
          description       : '一言説明は20文字以内です。',
          validationRules   : ['notEmpty', 'max'],
          inputType         : 'input',
          isDisabled        : false,
          descriptionMinify : true,
        },
        description  : {
          label             : 'ひろばの説明',
          description       : 'ひろばの説明文です。',
          validationRules   : ['notEmpty', 'max'],
          inputType         : 'textarea',
          isDisabled        : false,
          descriptionMinify : true,
        },
      },

      isDisabledFormFields  : false,

      additionalFormClass : [],
    }
  },

  watch : {
    isDisabled  : {
      handler(value){
        if(value === true){
          this.isDisabledButton     = true;
          this.buttonClass          = ['button-disabled'];
          this.additionalFormClass  = ['pa-message-additional-box-disabled'];

          this.isDisabledFormFields = true;
        }else{
          this.isDisabledButton     = false;
          this.buttonClass          = [];
          this.additionalFormClass  = [];

          this.isDisabledFormFields = false;
        }
      },
      immediate: true
    },

    isLoading   : {
      handler(value){
        if(value === true){
          this.isFormLoading = true;
        }else{
          this.isFormLoading = false;
        }
      }
    },

    isFormLoading : {
      handler(value){
        this.isDisabledFormFields = value;
      }
    },

    isDisabledFormFields  : {
      handler(value){
        if(value === true){
          this.disabledFields();
        }else{
          this.unDisabledFields();
        }
      },
      immediate: true
    },

    serverValidationError : {
      handler(data){
        if(data === null) return;
        
        console.log(data);
        if(data.first.category === 'validation'){
          this.unValidateField({
            fieldName : data.first.field,
            message   : data.first.message,
          });
        }
      },
      immediate: true,
      deep:true
    }
  },

  methods : {
    handleSubmit(){
      if(!this.checkFormPreValidation()) return;

      const characterItemStoreData = this.couldUseStoryItemValidation('castella');
      
      if( characterItemStoreData !== false ){
        this.displayUseStoryItemConfirmModal({
          characterItemStore    : characterItemStoreData,
          templateName          : 'createNewPark',

          itemRequireAmount     : 1,  // 使用するアイテムの数

          handleSubmitFunction  : async() => {
            this.$store.dispatch({
              type            : 'itemUseModal/updateOpenModal',
              isSubmitLoading : true,
            });

            await this.UXWaiting(500);

            //アイテム消費確認モーダルを閉じる
            this.$store.dispatch({
              type            : 'itemUseModal/updateOpenModal',
              value           : false,
              isSubmitLoading : false
            });

            this.$emit('onSubmit', this.formSet);

            // console.log('handleSubmit');
          },

          handleCancelFunction  : async () => {
            this.$store.dispatch({
              type  : 'itemUseModal/updateOpenModal',
              value : false,
              isSubmitLoading : false
            });

            // console.log('handleCancel');
          }
        });
      }
    },
    
    handleCancel(){
      this.$emit('onCancel');
    }
  }
}
</script>

<style lang="scss">
  @import "@/components/Pages/Office/MessageApp/MessageAppForm.scss";
</style>